import { Box, ListItem, Typography } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import RemoveIcon from "@mui/icons-material/Remove";
import type { ReactNode } from "react";

interface RuleListItemProps {
	readonly message: ReactNode;
	readonly criteriaMet: boolean;
	readonly testId: string;
}

export const RuleListItem: React.FC<RuleListItemProps> = ({ message, criteriaMet, testId }) => {
	return (
		<ListItem disableGutters>
			<Box display="flex" alignItems="center" gap={1}>
				{criteriaMet === true && <CheckIcon color="success" />}
				{criteriaMet === false && <RemoveIcon color="error" />}

				<Typography variant="body2" component="div" data-testid={testId}>
					{message}
				</Typography>
			</Box>
		</ListItem>
	);
};
